import React from 'react';
import Layout from '../../../layouts/index';
import CreateModal from '../components/modal/CreateModal';
import { useTranslation } from 'react-i18next';

const CreateUser = () => {
    const { t } = useTranslation();
    
    return (
        <Layout>
            <div className='space-y-5'>
                <h1 className='flex h-10 items-center justify-start text-xl md:text-2xl font-semibold'>{t('user.createTitle')}</h1>
                <CreateModal />
            </div>
        </Layout>
    );
};

export default CreateUser;
